import { ApolloLink } from '@apollo/client';

/**
 * Adds x-referer header containing the full referer URL.
 */
export const refererLink = new ApolloLink((operation, forward) => {
  operation.setContext((context: { headers: Record<string, unknown> }) => {
    if (globalThis.window?.location) {
      context.headers ??= {};
      context.headers['x-referer'] = globalThis.window.location.toString();
    }
    return context;
  });
  return forward(operation);
});
